import React, { useState } from 'react';
import Panel from '@prisjakt/ui-panel';
import T from '@prisjakt/ui-translate';
import { BodySmallText, FontEmphasis } from '@prisjakt/ui/text/variants';

import Placeholder from '../placeholder';
import PriceInformation from '../../price-information';
import { getSortedPrices } from '../utils';
import PriceListHeader from './price-list-header';
import PriceListFooter from './price-list-footer';
import PriceListBody from './price-list-body';
import * as S from '../styles';
import { GroupOptionEnum } from '../group-options/types';
import { IPriceListPanelProps } from './types';
import { getListPrices, getCommonListProps, getListLimits } from './utils';
import PriceListSplitExperiment from './price-list-split-experiment';

const PriceListPanel: React.FC<IPriceListPanelProps> = props => {
  const [showMorePrices, setShowMorePrices] = useState(false);
  const [showMoreUnfeaturedPrices, setShowUnfeaturedMorePrices] = useState(
    false
  );
  const sortedPrices = getSortedPrices(props.currentSort, props.prices);

  const [splitList, setSplitList] = useState<boolean>(false);

  const isGroupedList =
    splitList && props.currentGrouping === GroupOptionEnum.GROUP_ON_PARTNERS;

  const prices = getListPrices(sortedPrices, isGroupedList);
  const commonListProps = getCommonListProps(props);
  const listLimits = getListLimits(prices);

  return (
    <Panel>
      <PriceListSplitExperiment
        setSplitList={setSplitList}
        categoryId={props.category?.id}
      />
      <PriceListHeader
        sortedPrices={sortedPrices}
        me={props.me}
        currentSort={props.currentSort}
        currentGrouping={props.currentGrouping}
        handlePriceFilterCheckboxChange={props.handlePriceFilterCheckboxChange}
        priceFilters={props.priceFilters}
        quickFilters={props.quickFilters}
        splitList={splitList}
      />
      {props.storeStatistics && (
        <PriceInformation storeStatistics={props.storeStatistics} />
      )}

      {sortedPrices && sortedPrices.length > 0 ? (
        <>
          <PriceListBody
            sortedPrices={prices.mainList}
            showMorePrices={showMorePrices}
            numberOfVisiblePrices={listLimits.mainListLimit}
            splitList={isGroupedList}
            {...commonListProps}
          />
          <PriceListFooter
            showProductInformationTexts={props.showProductInformationTexts}
            sortedPrices={prices.mainList}
            showMorePrices={showMorePrices}
            numberOfVisiblePrices={listLimits.mainListLimit}
            setShowMorePrices={setShowMorePrices}
          />
          {isGroupedList &&
            prices.unfeaturedList &&
            prices.unfeaturedList.length > 0 && (
              <>
                <S.StyledHeader>
                  <T domain="product" product="splitlist-other.title">
                    splitlist-other.title
                  </T>
                </S.StyledHeader>
                <S.SplittedStoresInfo>
                  <BodySmallText
                    emphasis={FontEmphasis.MEDIUM}
                    style={{ display: 'inline-block' }}
                  >
                    <T domain="product" product="splitlist-other.description">
                      splitlist-other.description
                    </T>
                  </BodySmallText>
                </S.SplittedStoresInfo>
                <PriceListBody
                  sortedPrices={prices.unfeaturedList}
                  showMorePrices={showMoreUnfeaturedPrices}
                  numberOfVisiblePrices={listLimits.unfeaturedListLimit}
                  splitList={isGroupedList}
                  {...commonListProps}
                />
                <PriceListFooter
                  showProductInformationTexts={
                    props.showProductInformationTexts
                  }
                  sortedPrices={prices.unfeaturedList}
                  showMorePrices={showMoreUnfeaturedPrices}
                  numberOfVisiblePrices={listLimits.unfeaturedListLimit}
                  setShowMorePrices={setShowUnfeaturedMorePrices}
                />
              </>
            )}
        </>
      ) : (
        <Placeholder category={props.category} />
      )}
    </Panel>
  );
};

export default PriceListPanel;
